import { render, staticRenderFns } from "./HeaderBlock.vue?vue&type=template&id=04b1d661&scoped=true&"
import script from "./HeaderBlock.vue?vue&type=script&lang=ts&"
export * from "./HeaderBlock.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderBlock.vue?vue&type=style&index=0&id=04b1d661&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b1d661",
  null
  
)

export default component.exports